<template>
  <div class="teacher-list-wrapper">
    <!-- <div v-show="showLeftArrow" ref="leftArrow" class="left-arrow-wrapper">
      <div class="left-arrow" @click="clickLeftArrow()">
        <i class="iconfont icon-arrow-left-outline" />
      </div>
      <div class="blank-area-left" />
    </div> -->
    <div class="title-teacher">
      {{ $t('coursesDetail.teacher') }}
    </div>
    <div ref="teacherList" class="teacher-list">
      <div v-for="(item,index) in allTeacherList" :key="index" class="teacher-item" :class="(item.avatar && item.teacherType == 1)||locale==='sg'?'enterable':''" @click="goTeacherDetail(item)">
        <div class="avater">
          <div v-if="item.avatar" :style="{backgroundImage:`url(${item.avatar})`}" class="card-avater" />
        </div>
        <img v-if="(item.avatar && item.teacherType == 1)||locale==='sg'" alt="enter teacher detail" class="sign" v-lazy-load data-src="~assets/images/courses/enterable.png">
        <span v-if="(item.avatar && item.teacherType == 1)||locale==='sg'" class="bm-span" />
        <div class="teacher-center">
          <p class="teacher-name text-overflow-ellipsis" :title="item.sysName">
            {{ item.sysName }}
          </p>
          <p class="teacher-info  text-overflow-ellipsis" :title="item.teacherType==1?item.education:item.tutorDuty">
            {{ item.teacherType==1?item.education:item.tutorDuty }}
          </p>
          <p class="teacher-type text-overflow-ellipsis" :title="item.teacherType">
            {{ getTeacherType(item.teacherType) }}
          </p>
        </div>
      </div>
    </div>
    <!-- <div v-show="showRightArrow" ref="rightArrow" class="right-arrow-wrapper">
      <div class="blank-area-right" />
      <div class="right-arrow" @click="clickRightArrow()">
        <i class="iconfont icon-arrow-right-outline" />
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  props: {
    detailData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    locale() {
      return this.$store.state.locale
    },
    allTeacherList() {
      const allList = this.detailData.spec.teacherList.concat(this.detailData.spec.tutorList)
      return allList
    },
  },
  methods: {
    goTeacherDetail(teacherItem) {
      if ((teacherItem.avatar && Number(teacherItem.teacherType) === 1) || this.locale === 'sg') {
        const url = `/teachers/detail/${teacherItem.teacherId}`;
        this.$router.push(url)
      }
    },
    getTeacherType(type) {
      if (Number(type) === 1) {
        return this.$store.state.teacher.lecturerTitle
      }
      return this.$store.state.teacher.assistantTitle
    },
  },
}
</script>
<style lang="scss" scoped>
.teacher-list-wrapper {
  padding-top: 40px;

  .title-teacher {
    font-size: 32px;
    font-weight: 600;
    color: rgba(23, 43, 77, 1);
    line-height: 38px;
  }

  .teacher-list {
    display: flex;
    flex-wrap: wrap;

    .teacher-item {
      position: relative;
      display: flex;
      align-items: center;
      margin-top: 16px;
      width: 380px;
      height: 86px;
      padding: 15px 15px 15px 20px;
      box-sizing: border-box;
      background: #fff;
      border-radius: 10px;

      &:nth-child(2n+1) {
        margin-right: 20px;
      }

      &.enterable {
        cursor: pointer;
      }
    }

    .card-avater {
      width: 56px;
      height: 56px;
      margin-right: 8px;
      border-radius: 6px;
      background-size: cover;
    }

    .sign {
      width: 32px;
      height: 32px;
      position: absolute;
      right: 12px;
    }

    .teacher-center {
      width: 250px;

      .teacher-name {
        font-size: 18px;
        font-weight: 500;
        color: rgba(23, 43, 77, 1);
        line-height: 24px;
      }

      .teacher-info {
        max-width: 250px;
        margin-top: 1px;
        font-size: 12px;
        font-weight: 500;
        color: rgba(162, 170, 184, 1);
        line-height: 14px;
      }

      .teacher-type {
        padding: 2px 3px;
        margin-top: 6px;
        width: fit-content;
        background: rgba(244, 246, 250, 1);
        border-radius: 3px;
        color: var(--txt-color-lv2);
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;
      }
    }
  }
}
</style>
